module.exports = __webpack_public_path__ + "static/media/google-logo.f6ce5696.svg";